import { URLS } from 'core/dna/routing';

import { LogoutCallback } from 'auth/dna/types';

import AuthUrls from 'auth/urls';

export const defaultLogoutCallback: LogoutCallback = (options) => {
  options?.navigateTo?.(AuthUrls.home(options?.locale ?? URLS.defaultLocale));
};
